<div class="default-dialog-wrapper mat-elevation-z10">
    <form [formGroup]="approveForm">
        <div class="flex flex-row content">
        <div class="flex flex-col justify-between w-100-percent">
            <div class="flex flex-row w-100-percent">
            <h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fs-24 fw-700 mr-98">{{title}}</h1>
            <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
            </div>
            <div class="mat-subtitle-2 fw-500 mb-16" [innerHtml]="message"></div>
            <div class="flex flex-col">
                <div class="flex flex-row">
                    <span class="text-color fw-700 fs-12 mb-8">{{'EDGE_NETWORK_DETAILS.TICKET_ID' | transloco | uppercase }} <span class="mandatory">*</span></span>
                    <mat-icon svgIcon="info" class="icon-sm ml-4 mt-4" matTooltipClass="form-tooltip right" [matTooltip]="'EDGE_NETWORK_DETAILS.TICKET_INFO' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="ticketNumber" placeholder="{{'EDGE_NETWORK_DETAILS.TICKET_ID' | transloco}}" class="fw-400 h-48 fs-14 input-box" required id="ticket">
                <app-error [control]="approveForm.get('ticketNumber')"></app-error>
            </div>
            <div class="flex flex-col mt-24 mb-24">
                <span class="text-color fw-700 fs-12 mb-8">{{'EDGE_NETWORK_DETAILS.DESCRIPTION' | transloco | uppercase}} <span class="mandatory">*</span></span>
                <textarea formControlName="description" placeholder="{{'EDGE_NETWORK_DETAILS.DESCRIPTION_HERE' | transloco}}" class="fw-400 input-box pt-8" required id="description"></textarea>
                <app-error [control]="approveForm.get('description')"></app-error>
            </div>
            <mat-divider class="neutral-blue-6 mb-16 ml--30 mr--30"></mat-divider>
            <div class="flex flex-row justify-end w-100-percent">
            <button class="white mr-12" [matDialogClose]="false">{{'DIALOG.CANCEL'| transloco}}</button>
            <button class="accent"(click)="verifyForm()">{{confirmButtonText}}</button>
            </div>
        </div>
        </div>
    </form>
  </div>